export var HorizontalRule = 'hr';
//# sourceMappingURL=index.js.map